const tax_number = (content: string): string => {
  return content.replace(/[.,-]/g, '');
};
export default tax_number;
